import { getWindowData } from 'owa-window-data';

export function isTdsBox(): boolean {
    return getWindowData().location.hostname === 'exchangelabs.live-int.com';
}
